export class BankData {
  bankName!: string;
}
